import moment from 'moment';

import { ApiService }        from '../../app-lite/api/api.service';
import { DateParserService } from '../../app-lite/core/services/date-parser.service';

export class EditTimesheetCtrl {
  block       : ng.blockUI.BlockUIService;
  scheduleApi : any;

  constructor (
    private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
    private $scope           : ng.IScope,
    private $translate       : ng.translate.ITranslateService,
    private blockUI          : ng.blockUI.BlockUIService,
    private date             : string,
    private dateParsing      : DateParserService,
    private mechanicId       : string,
    private Schedule         : any,
    private timesheet        : any,
    private workshopAPI      : ApiService
  ) {
    this.block       = this.blockUI.instances.get('editTimesheetBlock');
    this.scheduleApi = new this.Schedule();
  }

  delete () : void {
    this.scheduleApi.delete(this.timesheet)
    .then(() => {
      this.$uibModalInstance.close(this.$translate.instant('JS_SPACE.MESSAGES.DELETED.SCHEDULE'));
    })
    .catch(err => {
      this.$uibModalInstance.dismiss(err);
    });
  }

  save () : void {
    this.block.start();

    this.scheduleApi.saveTimesheet(this.date, this.mechanicId, this.timesheet)
    .then(() => {
      this.$uibModalInstance.close(this.$translate.instant('JS_SPACE.MESSAGES.SAVED.SCHEDULE'));
    })
    .catch(err => {
      this.$uibModalInstance.dismiss(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

  selectTime ( event : any, property : string, unavailableTimesIndex : number ) : void {
    if (!unavailableTimesIndex
      && ( unavailableTimesIndex !== 0 )
      || this.timesheet.unavailable_times[unavailableTimesIndex].date
    ) {
      const picker = angular.element(event.currentTarget)
      .datetimepicker({
        initialDate : new Date(),
        showMeridian: true,
        startView   : 'day'
      })
      .on('changeDate', ( ev : any ) => {
        let date : Date | string = new Date(ev.date.valueOf());

        date = new Date(
          date.getUTCFullYear(),
          date.getUTCMonth(),
          date.getUTCDate(),
          date.getUTCHours(),
          date.getUTCMinutes()
        )
        .toISOString();
        if ( unavailableTimesIndex >= 0 ) {
          this.timesheet.unavailable_times[unavailableTimesIndex][property] = date;
        }
        else {
          this.timesheet.altered   = true;
          this.timesheet[property] = date;
        }

        if (!this.$scope.$$phase) {
          this.$scope.$apply();
        }

        angular.element(picker)
        .datetimepicker('hide');
      });

      angular.element('.datetimepicker')
      .addClass('hide-date');

      angular.element(picker)
      .datetimepicker('show');
    }
  }

  /**
    * when using the time from a date after daylight savings and adding
    * it to a date before daylight savings, moment is converting the hour to
    * be an hour later. Because of that, we set the hour, second, minute, millisecond
    * separately to ensure that daylight savings is unaffected.
    * bugfix/WOR-1155
    */
  setUnavailable () : void {
    this.workshopAPI.post(this.scheduleApi.routes.saveUnavailable, {
      unavailable_times: [{
        date            : this.date,
        entire_day      : true,
        mechanic_id     : this.mechanicId,
        local_start_time: moment(this.date)
          .hour(moment(this.timesheet.local_start_time).hour())
          .millisecond(moment(this.timesheet.local_start_time).millisecond())
          .minute(moment(this.timesheet.local_start_time).minute())
          .second(moment(this.timesheet.local_start_time).second())
          .format('YYYY-MM-DDTHH:mm:ssZ'),
        local_end_time: moment(this.date)
          .hour(moment(this.timesheet.local_end_time).hour())
          .millisecond(moment(this.timesheet.local_end_time).millisecond())
          .minute(moment(this.timesheet.local_end_time).minute())
          .second(moment(this.timesheet.local_end_time).second())
          .format('YYYY-MM-DDTHH:mm:ssZ')
      }]
    })
    .then(() => {
      this.$uibModalInstance.close(this.$translate.instant('JS_SPACE.MESSAGES.SAVED.SCHEDULE'));
    })
    .catch(err => {
      this.$uibModalInstance.dismiss(err);
    });
  };
}
